module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qleg2-fa8bdd488da293cf7fdea9a05538f6a5.jpg";